<template>
  <VMenu class="selector-list list-choice" :offset="[0, 8]" data-testid="base-select-choice-list">
    <template #activator="{ props }">
      <span v-if="label" v-bind="props" data-testid="base-select-choice-list-activator"
        >{{ label }}
        <VIcon :color="iconColor" size="12" data-testid="base-select-choice-list-icon"
          >mdi-radiobox-marked</VIcon
        ></span
      >
    </template>
    <VList min-width="150" class="list-choice-select" data-testid="base-select-choice-list-options">
      <VCheckbox
        v-for="(option, index) in options"
        :key="`origin-form-${index}`"
        v-model="formOrigin"
        :label="option.label"
        :value="option.value"
        class="select-option py-4"
        hide-details
        :data-testid="'base-select-choice-list-option-' + index"
      />
    </VList>
  </VMenu>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: "",
  },
  iconColor: {
    type: String,
    default: "",
  },
  options: {
    required: true,
    type: Array,
  },
});

const formOrigin = defineModel("formOrigin", { type: Array });
</script>

<style lang="scss" scoped>
.selector-list {
  &:hover {
    cursor: pointer;
  }
}

.list-choice-select {
  background: white;
  color: black;
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  z-index: 100;
}
.select-option {
  margin: 0px;
  padding-left: 24px;

  &:hover {
    background: #f2f2f2;
  }
}
</style>
